<template>
  <div class="content-container">
    <div class="pc-nav d-none d-lg-block">
      <div class="container">
        <p class="title">行业音视频解决方案</p>
        <p class="subtitle">
          Zealcomm峰畅科技通过视频原生技术重构数智化企业服务。以基于WebRTC标准的、更适合于企业端应用的音视频底<br />座、智能音视频业务中台、可编程的智能视频数字劳动力引擎，帮助金融、政务、医疗、互联网营销类型的客户快速落<br />地远程服务场景。通过自研的智能视频远程服务平台，解决AI技术在远程服务类场景中落地的“最后一公里”问题。
        </p>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="mobile-container">
        <p class="title">行业音视频解决方案</p>
        <p class="subtitle">
          Zealcomm峰畅科技通过视频原生技术重构数智化企业服务。以基于WebRTC标准的、更适合于企业端应用的音视频底座、智能音视频业务中台、可编程的智能视频数字劳动力引擎，帮助金融、政务、医疗、互联网营销类型的客户快速落地远程服务场景。通过自研的智能视频远程服务平台，解决AI技术在远程服务类场景中落地的“最后一公里”问题。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  .content-container {
    .pc-nav {
      padding-bottom: 180px;
      overflow: hidden;
      background-image: url("https://zealcomm-site-assets.zealcomm.cn/new-product/solution-background.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      .container {
        .title {
          margin-top: 150px;
          color: #fff;
          font-size: 48px;
          font-weight: 600;
        }

        .subtitle {
          margin-top: 36px;
          color: #fff;
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
    .mobile {
      padding-bottom: 44px;
      overflow: hidden;
      background-image: url("~assets/img/solution/solution-mobile-background.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .mobile-container {
        .title {
          margin: 48px 0 0 19px;
          color: #fff;
          font-size: 27px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
        }

        .subtitle {
          margin: 18px 28px 0 19px;
          color: #fff;
          font-size: 12px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }
</style>
